import React from 'react';
import PropTypes from 'prop-types';
import Container from 'components/container';
import Header from 'components/header';

import Layout from './layout';
import LayoutContent from './layout-content';

const LayoutWithHeader = ({ children, steps, minWidth, maxWidth, ...props }) => (
  <Layout {...props}>
    <Header steps={steps} />
    <LayoutContent>
      <Container minWidth={minWidth} maxWidth={maxWidth}>
        {children}
      </Container>
    </LayoutContent>
  </Layout>
);

export default LayoutWithHeader;

LayoutWithHeader.propTypes = {
  children: PropTypes.node.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({})),
  minWidth: PropTypes.number, // New prop types
  maxWidth: PropTypes.number, // New prop types
};

LayoutWithHeader.defaultProps = {
  steps: null,
  minWidth: null,
  maxWidth: null,
};
